export default "__VITE_ASSET__DbAJUuKD__"